<template>
    <div id="content">
        <router-view></router-view>
       
    </div>
</template>

<script>

    export default {
        
    }
</script>

<style lang="less" scoped>
#content{
	width: 100%;
	margin:0 100px;
}
</style>